import React from 'react';

import { getText } from 'shared/utils/Text';

const GamblingLiability = () => (
  <div className="gambling-liablity aside-box">
    <h2 className="gambling-liablity__title">
      {getText('calendar-gambling-liability-title')}
    </h2>
    <p>
      {getText('calendar-gambling-liability-stodlinjen')},{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://stodlinjen.se">
        {getText('calendar-gambling-liability-stodlinjen-url')}
      </a>
      , {getText('calendar-gambling-liability-stodlinjen-phone')}
    </p>
    <p>
      {getText('calendar-gambling-liability-spelpaus')},{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://spelpaus.se">
        {getText('calendar-gambling-liability-spelpaus-url')}
      </a>
    </p>
    <p>
      {getText('calendar-gambling-liability-spelfriheten')},{' '}
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://spelfriheten.se"
      >
        {getText('calendar-gambling-liability-spelfriheten-url')}
      </a>
    </p>
  </div>
);

export default GamblingLiability;
